/* ShopGuide: open the box quick view from the visible "Nutrition & ingredients" button or the product photo.
   Reuses the existing quick view: it clicks the card's .svg--zoom-icon, so custom.js keeps handling open, close and focus. */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.cck-details-btn, .bundle-product > .bundle-product-image img');
    if (!trigger) return;

    var card = trigger.closest('.bundle-product');
    var zoom = card && card.querySelector('.svg--zoom-icon');
    if (!zoom) return;

    event.preventDefault();
    zoom.click();
  });
})();
